import { apiClient } from './client.tsx';
import type { ParkingContract } from '../models/parking-contract.ts';
import type {
  CreateDefaultParkingContractRequest,
  CreateSpecifyParkingContractRequest,
  UpdateDefaultParkingContractRequest,
  UpdateSpecifyParkingContractRequest,
  SetupParkingLotsRequest,
  UpdateParkingLotsRequest,
  UploadParkingContractAttachmentRequest,
  TerminateParkingContractRequest,
  DeleteParkingContractAttachmentRequest,
} from '../api/requests/parking-contract-request.ts';

export const fetchParkingContract = (partnerId: string, id: string) =>
  apiClient
    .get<{
      data: ParkingContract;
    }>(`/v2/partners/${partnerId}/parking_contracts/${id}`)
    .then((res) => res.data);

export const createParkingContract = ({
  partnerId,
  ...restReq
}: CreateDefaultParkingContractRequest | CreateSpecifyParkingContractRequest) =>
  apiClient
    .post<{
      data: { id: string };
    }>(`/v2/partners/${partnerId}/parking_contracts`, restReq, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then((res) => res.data);

export const updateParkingContract = ({
  partnerId,
  id,
  ...restReq
}: UpdateDefaultParkingContractRequest | UpdateSpecifyParkingContractRequest) =>
  apiClient
    .put<string>(`/v2/partners/${partnerId}/parking_contracts/${id}`, restReq)
    .then((res) => res.data);

export const deleteParkingContract = (partnerId: string, id: string) =>
  apiClient
    .delete<string>(`/v2/partners/${partnerId}/parking_contracts/${id}`)
    .then((res) => res.data);

export const setupParkingLots = ({
  partnerId,
  id,
  ...restReq
}: SetupParkingLotsRequest) =>
  apiClient
    .put<string>(
      `/v2/partners/${partnerId}/parking_contracts/${id}/setup_parking_lots`,
      restReq,
    )
    .then((res) => res.data);

export const updateParkingLots = ({
  partnerId,
  id,
  ...restReq
}: UpdateParkingLotsRequest) =>
  apiClient
    .put<string>(
      `/v2/partners/${partnerId}/parking_contracts/${id}/update_parking_lots`,
      restReq,
    )
    .then((res) => res.data);

export const publishParkingContract = (partnerId: string, id: string) =>
  apiClient
    .post<string>(`/v2/partners/${partnerId}/parking_contracts/${id}/publish`)
    .then((res) => res.data);

export const terminateParkingContract = ({
  partnerId,
  id,
  ...restReq
}: TerminateParkingContractRequest) =>
  apiClient
    .post<string>(
      `/v2/partners/${partnerId}/parking_contracts/${id}/terminate`,
      restReq,
    )
    .then((res) => res.data);

export const uploadParkingContractAttachment = ({
  partnerId,
  contractId,
  ...restReq
}: UploadParkingContractAttachmentRequest) =>
  apiClient
    .post<string>(
      `/v2/partners/${partnerId}/parking_contracts/${contractId}/upload`,
      restReq,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )
    .then((res) => res.data);

export const downloadParkingContractAttachment = (
  partnerId: string,
  contractId: string,
  attachmentId: string,
) =>
  apiClient
    .get<{
      data: { attachmentId: string; downloadUrl: string };
    }>(
      `/v2/partners/${partnerId}/parking_contracts/${contractId}/attachments/${attachmentId}/get_download_url`,
    )
    .then((res) => res.data);

export const deleteParkingContractAttachment = ({
  partnerId,
  contractId,
  attachmentId,
}: DeleteParkingContractAttachmentRequest) =>
  apiClient
    .delete<string>(
      `/v2/partners/${partnerId}/parking_contracts/${contractId}/attachments/${attachmentId}`,
    )
    .then((res) => res.data);
